import React from 'react';
import FormElement from 'Components/Core/Form/FormElement';
import 'CSS/Forum/DialogAddBBCode.css';
import DialogAddBBCode from './DialogAddBBCode';

export default function DialogAddText(props) {

    const x = props.x;
	const type = (typeof props.type === 'undefined') ? 'text' : props.type; 

	return (

		<DialogAddBBCode 
			id={props.id} 
			x={x}   
			title={props.title} 
			tag={props.tag} 
			focus={() => {x.waf.setFocus(props.id, 'text')}}
			reset={() => {	
				x.waf.set(props.id, 'text', '');
			}}
			answerTo={props.answerTo} 
		 >
			<FormElement type={type} x={x}   wafId={props.id} id="text" title="Text" />
		</DialogAddBBCode>

	)
};
